import { render, staticRenderFns } from "./Certificate.vue?vue&type=template&id=b469db24&scoped=true"
import script from "./Certificate.vue?vue&type=script&lang=js"
export * from "./Certificate.vue?vue&type=script&lang=js"
import style0 from "./Certificate.vue?vue&type=style&index=0&id=b469db24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b469db24",
  null
  
)

export default component.exports